module.exports = __webpack_public_path__ + "img/4a5377e.webp";